<template>
  <b-container
    fluid
    class="d-flex vh-100 justify-content-center align-items-center bg-main"
  >
    <div class="text-center w-100">
      <img :src="logo" alt="Logo" class="logo mb-4" style="max-height: 206px;" />
      <b-row class="justify-content-center">
        <b-col cols="12" md="8" lg="5" xl="4" class=" box-shadow-primary login-wrapper bg-white px-12 py-12" style="border-radius: 12px; ">
          <b-form-group
            id="field-email"
            label-for="emailLogin"
            :state="stateEmail" 
            class="mt-3"
          >
            <b-form-input
              id="emailLogin"
              type="email"
              placeholder="email"
              v-model="emailLogin"
              :state="stateEmail"
              trim
              @keydown.enter.prevent="goLogin"
              style="height: 46px;border-radius: 10px;"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="field-password"
            label-for="passwordLogin"
            :state="statePassword"
            style="margin-bottom: 24px;"
          >
            <b-form-input
              id="passwordLogin"
              :type="'password'"
              minlength="8"
              placeholder="รหัสผ่าน"
              v-model="passwordLogin"
              :state="statePassword"
              @keydown.enter.prevent="goLogin"
              style="height: 46px;border-radius: 10px;" 
              trim
            ></b-form-input> 
          </b-form-group>

          <b-row >
            <b-col cols="12" class="text-left text-dark">
              <router-link to="/forgetpassword">ลืมรหัสผ่าน ?</router-link>
            </b-col>
          </b-row>

          <b-button
            @click="goLogin"
            id="btnLogin"
            class="bg-yellow border-0 text-dark btn-block my-12"
            style="margin-bottom: 60px;height: 58px;border-radius: 1rem;font-size: 20px;"
          >
            เข้าสู่ระบบ
          </b-button>

          <div class="text-center">
            ผู้ใช้งานใหม่?
            <strong><router-link to="/register">สมัครสมาชิก</router-link></strong>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import logo from "./../../public/logo-2.png"; 
import Swal from "sweetalert2";
export default {
  name: "loginPage",
  data() {
    return {
      passwordLogin: "",
      emailLogin: "",
      isLoading: false,
      logo: logo,
    };
  },
  props: {
    msg: String,
  }, 
  computed: {
    statePassword() {
      if (this.passwordLogin.length != 0) {
        return true;
      } else {
        return false;
      }
    },
    stateEmail() {
      if (this.emailLogin.length != 0) {
        return true;
      } else {
        return false;
      }
    },
    invalidFeedbackEmail() {
      if (this.emailLogin.length >= 0) {
        return "โปรดกรอกข้อมูล";
      }
      return "โปรดกรอกข้อมูล";
    },
    invalidFeedbackPassword() {
      if (this.passwordLogin.length >= 0) {
        return "โปรดกรอกข้อมูล";
      }
      return "โปรดกรอกข้อมูล";
    },
  },
  methods: {
    showPassword: function () {
      var passwordInput = document.getElementById("passwordLogin");
      if (passwordInput.type == "password") {
        passwordInput.type = "text";
      } else {
        passwordInput.type = "password";
      }
    },
    goLogin() {
      const path = `/`;
      let data = {
        email: this.emailLogin,
        password: this.passwordLogin,
      };
      this.isLoading = true;
      this.$store
        .dispatch("Auth/login", data)
        .then((response) => {
          this.isLoading = false;
          if (response.code == 200) {
            Swal.fire({
              title: "สำเร็จ!",
              confirmButtonText: `ตกลง`,
              icon: "success",
              showClass: {
                popup: "animate__animated animate__fadeInDown",
              },
              hideClass: {
                popup: "animate__animated animate__fadeOutUp",
              },
            }).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                this.$router.push(path);
              }
            });
          }
        })
        .catch(() => {
          this.isLoading = false;
          Swal.fire(
            "ผิดพลาด!",
            "ไม่สามารถเข้าสู่ระบบได้ โปรดตรวจสอบอีเมล/รหัสผ่าน",
            "error"
          );
        });
    },
    // socialGoogleLogin: function () {
    //   const provide = new firebase.auth.GoogleAuthProvider();
    //   firebase
    //     .auth()
    //     .signInWithPopup(provide)
    //     .then((result) => {
    //       if (result.credential) {
    //         /** @type {firebase.auth.OAuthCredential} */
    //         var credential = result.credential;
    //
    //         // This gives you a Google Access Token. You can use it to access the Google API.
    //         var token = credential.accessToken;
    //         // ...
    //       }
    //       // create user in db
    //       let obj = {
    //         google_id: result.additionalUserInfo.profile.id,
    //         fullname: result.additionalUserInfo.profile.name,
    //         email: result.additionalUserInfo.profile.email,
    //         profile_image: result.additionalUserInfo.profile.picture,
    //         user_type_id: 1,
    //       };
    //     })
    //     .catch((err) => {
    //     });
    // },
    // async socialFacecbookLogin() {
    //   await this.loadFacebookSDK(document, "script", "facebook-jssdk");
    //   await this.initFacebook();
    //   const provide = new firebase.auth.FacebookAuthProvider();
    //   firebase
    //     .auth()
    //     .signInWithPopup(provide)
    //     .then((result) => {
    //       // create user in db
    //       let obj = {
    //         facebook_id: result.additionalUserInfo.profile.id,
    //         fullname: result.additionalUserInfo.profile.name,
    //         email: result.additionalUserInfo.profile.email,
    //         profile_image: result.user.photoURL + "?height=500",
    //         user_type_id: 1,
    //       };
    //     })
    //     .catch((err) => {
    //       alert("Oops. " + err.message);
    //     });
    // },
    // async initFacebook() {
    //   window.fbAsyncInit = function () {
    //     window.FB.init({
    //       appId: "932195234193471",
    //       cookie: true,
    //       xfbml: true,
    //       version: "v9.0",
    //     });
    //   };
    // },
    // async loadFacebookSDK(d, s, id) {
    //   var js,
    //     fjs = d.getElementsByTagName(s)[0];
    //   if (d.getElementById(id)) {
    //     return;
    //   }
    //   js = d.createElement(s);
    //   js.id = id;
    //   js.src = "https://connect.facebook.net/en_US/sdk.js";
    //   fjs.parentNode.insertBefore(js, fjs);
    // },
  },
};
</script> 
<style>
a{
  color: black !important;
}
</style>